import { Star, MapPin, Phone, AlertCircle, Wallet, Clock } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

export default function Restaurantes() {
  const { t } = useT();

  const list = [
    {
      key: "barsede",
      bg: "linear-gradient(135deg, #1a4d28 0%, #2e7d32 100%)",
      emoji: "⚽",
      badge: { txt: "⚡ Na Vila — ~200m", green: true },
      nome: "Bar-Sede FC Mexilhoeira",
      stars: 5,
      ratingTxt: "4.6 Google",
      desc: "O favorito dos locais. Pratos do dia com cozinha portuguesa a preços imbatíveis. Ambiente descontraído e pessoal simpático. Ideal para almoços rápidos e autênticos.",
      metas: [
        { Icon: MapPin, txt: "Mexilhoeira Grande" },
        { Icon: Clock, txt: t.restaurants.lunch },
      ],
    },
    {
      key: "adega",
      bg: "linear-gradient(135deg, #5a1c2a 0%, #8a2940 100%)",
      emoji: "🍷",
      badge: { txt: "⚡ Na Vila — ~400m", green: true },
      nome: "Adega Vila Lisa",
      stars: 5,
      ratingTxt: "Ícone desde 1981",
      desc: "Menu único de degustação: pernil de porco, polvo no forno, xerém de lingueirão. ~40€/pax com bebidas. Uma experiência memorável que merece a viagem.",
      metas: [
        { Icon: MapPin, txt: "Rua Francisco Bívar 55" },
        { Icon: Phone, txt: "282 968 478" },
        { Icon: AlertCircle, txt: t.restaurants.reservation },
      ],
    },
    {
      key: "choupana",
      bg: "linear-gradient(135deg, #8a3e1c 0%, #c0492c 100%)",
      emoji: "🐷",
      badge: { txt: "🚗 5–10 min", green: false },
      nome: "Restaurante A Choupana",
      stars: 4,
      ratingTxt: "",
      desc: "Ambiente familiar, leitão assado e pratos algarvios tradicionais. Excelente relação qualidade-preço. Popular entre locais e visitantes regulares.",
      metas: [
        { Icon: MapPin, txt: "Mexilhoeira Grande" },
        { Icon: Wallet, txt: t.restaurants.goodPrice },
      ],
    },
    {
      key: "solar",
      bg: "linear-gradient(135deg, #4f6328 0%, #7a8a3c 100%)",
      emoji: "🌿",
      badge: { txt: "🚗 5–10 min", green: false },
      nome: "Solar do Farelo",
      stars: 4,
      ratingTxt: "",
      desc: "Menu fixo ao almoço: couvert, vinho da pipa à discrição, prato, sobremesa e café. Ambiente rústico e campestre. Recomenda-se reserva.",
      metas: [
        { Icon: MapPin, txt: "Várzea do Farelo" },
        { Icon: Phone, txt: "282 471 405" },
      ],
    },
  ];

  return (
    <section id="restaurantes" className="py-20 md:py-28 bg-[#f6ecd9]" data-testid="restaurantes-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal max-w-2xl">
          <p className="section-label">{t.restaurants.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-[#0e1a3f] leading-tight">
            {t.restaurants.title1}
            <br />
            <em className="text-[#1e3a8a]">{t.restaurants.title2}</em>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {list.map((r) => (
            <article
              key={r.key}
              className="reveal card-lift bg-white rounded-2xl overflow-hidden ring-1 ring-[#0e1a3f]/10 flex flex-col"
              data-testid={`restaurante-${r.key}`}
            >
              <div className="h-40 flex items-center justify-center text-6xl" style={{ background: r.bg }}>
                <span aria-hidden="true">{r.emoji}</span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span
                  className={`inline-flex w-fit text-[10px] px-2.5 py-1 rounded-full font-bold uppercase tracking-wider ${
                    r.badge.green ? "bg-[#dcefd6] text-[#234d2a]" : "bg-[#d6e2f5] text-[#1e3a8a]"
                  }`}
                >
                  {r.badge.txt}
                </span>
                <h3 className="font-display text-lg mt-3 text-[#0e1a3f] leading-tight">{r.nome}</h3>
                <div className="flex items-center gap-1 text-[#c89033] mt-1">
                  {[...Array(r.stars)].map((_, i) => (
                    <Star key={i} size={12} className="fill-current" />
                  ))}
                  {r.ratingTxt && <span className="ml-2 text-[11px] text-[#0e1a3f]/65">· {r.ratingTxt}</span>}
                </div>
                <p className="mt-3 text-xs text-[#0e1a3f]/75 leading-relaxed flex-1">{r.desc}</p>
                <div className="mt-4 space-y-1.5">
                  {r.metas.map((m) => (
                    <p key={m.txt} className="flex items-center gap-1.5 text-[11px] text-[#0e1a3f]/70">
                      <m.Icon size={12} className="text-[#c89033] flex-shrink-0" /> {m.txt}
                    </p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
